export default "__VITE_ASSET__4fe9019c__"